import React from "react";
import styled from "styled-components";
import Card from "./Card"

const HomeContactContainer = styled.div`

  margin: 0 0 0 0;
  width: 100%;

  
`
const ContactInfoContainer = styled.div`
  width: 66%;
  position: absolute;
  z-index: 5;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
`

const GoogleMap = styled.div`
    width: 100%;
    position: relative;

  .map {
    width: 100%;
    min-height: 75vh;
  }
`

const InfoHeader = styled.h4`
font-weight: 700;
color: #004e92;
`

const Address = styled.p`
margin: 1rem 0 1rem 0;
font-weight: 700;
`
const PhoneNumber = styled.a`
color: #004e92;
`

const HoursTitle = styled.h6`
font-weight: 700;
color: #004e92;
margin: 0 0 1rem 0;
`

const HourDetail = styled.p`
font-weight: 700;
`

const HomeContactSpanish = () => {
  return (
    <HomeContactContainer>
      <GoogleMap>
        <iframe className="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.174857231944!2d-98.29605388511517!3d26.320836883386157!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8665a5761fff86ff%3A0x5d9e9987e9610405!2sAir%20Service%20Experts!5e0!3m2!1sen!2sus!4v1586143368724!5m2!1sen!2sus"
                frameBorder="0" allowFullScreen="" aria-hidden="false"
                tabIndex="0"></iframe>
        <ContactInfoContainer>
          <Card highlight="red" m="0 0 0 0" p="1rem 0 1rem 1.5rem">
            <div className="columns">
              <div className="column is-two-thirds-desktop is-12">
                <InfoHeader>Air Service Experts</InfoHeader>
                <Address>11723 Bryan Rd, Mission, TX 78573</Address>
                <PhoneNumber href="tel:+1956-580-8181">(956) 580-8181</PhoneNumber>
              </div>
              <div className="column is-one-third-desktop is-12">
                <HoursTitle>Horas de Operación</HoursTitle>
                <HourDetail>Lunes a Domingo</HourDetail>
                <HourDetail>8:00 AM - 7:00 PM</HourDetail>
              </div>
            </div>

          </Card>
        </ContactInfoContainer>
      </GoogleMap>
    </HomeContactContainer>
  )
}


export default HomeContactSpanish;